var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("settings-editor-base", {
    attrs: { label: _vm.label, tooltip: _vm.tooltip },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var inputId = ref.inputId
          return [
            _c("textarea", {
              staticClass: "form-control",
              attrs: { id: inputId, cols: _vm.cols, rows: _vm.rows },
              domProps: { value: _vm.value },
              on: {
                input: function($event) {
                  return _vm.$emit("input", $event.srcElement.value)
                }
              }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }